import instance from 'services/api';

/**
 * Profit IQ lives on api01, which the shared axios instance already points at
 * (`REACT_APP_API_BASE_URL`) with the bearer token and `business` header
 * attached. Nothing here is business-specific in the URL: the backend scopes
 * every call on that header.
 */
const client = instance;

/**
 * api01 wraps every payload in `{ status, message, data }`; the Profit IQ
 * screens consume the domain objects directly, so every call unwraps `data`.
 */
export const unwrap = (r) => r?.data?.data;

/** Builds a query string, dropping empty values. */
export function profitQuery(params) {
  const parts = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null && value !== '')
    .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`);
  return parts.length ? `?${parts.join('&')}` : '';
}

export default client;
